import classNames from 'classnames';
import { DetailedHTMLProps, LabelHTMLAttributes } from 'react';

interface CheckboxLabelProps extends DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
  disabled?: boolean;
}

export default function CheckboxLabel({
  className,
  disabled,
  children,
  ...props
}: CheckboxLabelProps) {
  return (
    <label
      className={classNames(
        '[&_input]:mt-[5px] flex space-x-2',
        disabled ? 'text-slate-400' : 'cursor-pointer',
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
}
